import { gql } from "@apollo/client";
import { ProjectCardFieldsFragment } from "@govlaunch/project";

export default gql`
  mutation EditGroup($id: ObjectId!, $group: GroupInput!) {
    updateGroup(id: $id, group: $group) {
      _id
      slug
      name
      about
      website
      location
      membersCount
      productsCount
      feedCount
      viewerIsMember
      headedByAdmins
      viewerCanHeadContent
      awards {
        _id
        name
      }
      governments {
        _id
        name
        logo
        slug
      }
      vendors {
        _id
        name
        logo
        slug
      }
      pendingRequests {
        ... on GovernmentGroupRequest {
          _id
          government {
            _id
            logo
            name
            slug
            city {
              _id
              name
              country
              countryName
            }
          }
          createdAt
        }
        ... on VendorGroupRequest {
          _id
          vendor {
            _id
            logo
            name
            slug
          }
          createdAt
        }
      }
      socialMedia {
        instagram
        youtube
        facebook
        linkedin
        twitter
      }
      products {
        _id
        name
        logo
        slug
        company {
          _id
          name
          slug
        }
      }
      outsideProducts {
        _id
        name
        url
        logo
      }
      newsworthy {
        title
        siteName
        favicon
        url
        description
        addedAt
      }
      projectsCount
      projects(limit: 100, audience: PRIVATE) {
        items {
          _id
          ...ProjectCardFields
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
      projectsFromGovernments(limit: 6) {
        items {
          _id
          ...ProjectCardFields
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
      resources {
        ... on LinkResource {
          url
          title
          addedAt
          type
        }
        ... on DownloadResource {
          url
          title
          filename
          addedAt
          type
        }
        ... on TextResource {
          title
          body
          addedAt
          type
        }
      }
      logo
      visibility
      viewerCanRemoveMembers
      members {
        items {
          ... on PendingUser {
            _id
            slug
            firstName
            fullName
            avatar
            jobTitle
            createdAt
          }
          ... on GovernmentUser {
            _id
            slug
            firstName
            jobTitle
            fullName
            avatar
            title
            createdAt
          }
          ... on VendorUser {
            _id
            slug
            firstName
            jobTitle
            fullName
            avatar
            title
            createdAt
          }
        }
        pageInfo {
          endCursor
          hasNextPage
        }
      }
    }
  }

  ${ProjectCardFieldsFragment}
`;
